import React from 'react';
import PropTypes from 'prop-types';

import ActionText from './ActionText';

export default function Banner({ children, styles }) {
    return (
        <div className="banner-container" style={styles}>
            <div className="banner-text-container">{children}</div>
        </div>
    );
}

Banner.propTypes = {
    styles: PropTypes.object,
};

Banner.ActionText = ActionText;
